/* index.js */

"use strict";

const _ = require("lodash");
const Button = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const { CONDITIONAL_DATA } = require("../cellEditors/conditionalDropdownData");

// const { labelByTypeData } = require("../CustomFieldsConstants");

module.exports = {
    checkboxFormatter,
    selectFormatter,
    // dataTypeFormatter,
    typeInfoFormatter,
    descriptionFormatter,
    defaultValueFormatter,
    deleteButtonFormatter,
    solutionFormatter,
    catFormatter,
    fieldFormatter,
    deleteRow,
    conditionalFormat,
    sortTypeFormatter,
    rowOrientationFormatter,
    colorPicker,
    conditionDropdown,
    sortOrderFormatter,
    aggregateFormatter,
    headingFormatter,
    countFormatter
};

function checkboxFormatter(row, cell, value, columnDef, dataContext) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(false);

        if (dataContext.isUnavailable) {
            checkbox.classList.add("disabled");
        }
    }
    return checkbox.outerHTML;
}

function selectFormatter(row, cell, value /*, columnDef, dataContext*/) {
    return value || "-";
}
// function dataTypeFormatter(row, cell, value, columnDef, dataContext) {
//     // return labelByTypeData(value, dataContext.typeInfo) || "";
// }

function descriptionFormatter(row, cell, value /*, columnDef, dataContext*/) {
    const description = document.createElement("div");
    description.setAttribute("title", value);
    description.classList.add("description");
    description.innerText = value || "";
    return description.outerHTML;
}

function headingFormatter(row, cell, value, columnDef, dataContext) {
    const heading = document.createElement("div");
    heading.setAttribute("title", value);
    heading.classList.add("column-title");
    heading.innerText = value || "";
    if (dataContext.isUnavailable) {
        heading.classList.add("disabled");
    }
    return heading.outerHTML;
}

function deleteButtonFormatter(row, cell, value, columnDef, dataContext) {
    const button = document.createElement("base-icon-gl");
    button.dataset.icon = "common.trash_bin";
    button.setDarkTheme(false);

    button.setAttribute("aria-label", `delete ${dataContext.name}`);
    button.setAttribute("role", "button");

    button.dataset.uuid = dataContext.id;
    button.dataset.action = "delete";

    return button.outerHTML;
}

const DATA_TYPES = {
    String: stringTypeFormatter,
    Number: numberTypeFormatter,
    Enum: enumTypeFormatter,
    Boolean: () => ""
};

function typeInfoFormatter(row, cell, value, columnDef, dataContext) {
    const dataType = dataContext.dataType || "";
    const typeInfoValue = value || "";

    const typeFormatter = DATA_TYPES[dataType];

    return typeFormatter ? `<div class="type-info type-${dataType}">${typeFormatter(typeInfoValue || {})}</div>` : "";
}

/**
 *
 * @param {Object}   enumTypeInfo
 * @param {string[]} [enumTypeInfo.ids]         - list of enum Ids
 * @param {string[]} [enumTypeInfo.labels]      - list of enum labels
 * @param {boolean}  [enumTypeInfo.multiSelect] - multi-select flag
 * @returns {string} - HTML markup string
 */
function enumTypeFormatter(enumTypeInfo) {
    const multiSelect = Boolean(enumTypeInfo.multiSelect);
    let labels = enumTypeInfo.labels || [];
    const valueSpan = document.createElement("span");

    labels = labels.join(", ");
    valueSpan.setAttribute("title", labels);
    valueSpan.innerText = labels;

    const hasInfo = labels.length;
    const info = [
        multiSelect && `<span class="boolean-state">Multiple</span>`,
        labels && `<span class="values-list" title="${labels}">${labels}</span>`
    ]
        .filter(Boolean)
        .join("<br />");

    return hasInfo ? info : "";
}

/**
 *
 * @param {Object}  numberTypeInfo
 * @param {Object}  [numberTypeInfo.Number]             - number type info object
 * @param {number}  [numberTypeInfo.Number.max]         - max value for number type
 * @param {number}  [numberTypeInfo.Number.min]         - min value for number type
 * @param {boolean} [numberTypeInfo.Number.onlyInteger] - min value for number type
 * @returns {string} - HTML markup string
 */
function numberTypeFormatter(numberTypeInfo) {
    const data = numberTypeInfo.Number || {};
    const onlyInteger = Boolean(data.onlyInteger);

    const hasInfo = Number.isFinite(data.min) || Number.isFinite(data.max) || onlyInteger;
    const info = [
        onlyInteger && `<span title="is Integer" class="boolean-state">${onlyInteger ? "Integers only" : ""}</span>`,
        Number.isFinite(data.min) && `<span title="${data.min}">min: ${data.min}</span>`,
        Number.isFinite(data.max) && `<span title="${data.min}">max: ${data.max}</span>`
    ]
        .filter(Boolean)
        .join("<br />");
    return hasInfo ? info : "";
}

/**
 *
 * @param {Object} stringTypeInfo
 * @param {Object} [stringTypeInfo.String]         - string type info object
 * @param {string} [stringTypeInfo.String.pattern] - regexp validation pattern
 * @returns {string} - HTML markup string
 */
function stringTypeFormatter(stringTypeInfo) {
    const data = stringTypeInfo.String || {};
    const hasInfo = data.pattern;

    const info = `
        <div>Pattern: </div>
        <span title="${data.pattern}">${data.pattern}</span>
    `;
    return hasInfo ? info : "";
}

function defaultValueFormatter(row, cell, value, columnDef, dataContext) {
    const { dataType, typeInfo: { ids = [], labels = [] } = {} } = dataContext;
    let outputValue = _.isUndefined(value) ? "" : String(value);

    if (dataType === "Boolean") {
        return outputValue.toUpperCase();
    }

    if (dataType === "Enum") {
        outputValue = []
            .concat(value)
            .map((id) => labels[ids.indexOf(id)])
            .join(", ");
    }
    const span = document.createElement("span");
    span.classList.add("default-value");
    span.setAttribute("title", outputValue);
    span.innerText = outputValue;

    return span.outerHTML;
}

function solutionFormatter(row, cell, value, columnDef, dataContext) {
    const { category, solutions } = dataContext;
    let soln = value || Object.keys(solutions[category])[0];
    const span = document.createElement("span");
    span.classList.add("soln-value");
    if (soln === "0") {
        soln = " - ";
        span.classList.add("disabled");
    }
    span.setAttribute("title", soln);
    span.innerText = soln;

    return span.outerHTML;
}

function catFormatter(row, cell, value, columnDef, dataContext) {
    const { solutions } = dataContext;
    let cat = value || Object.keys(solutions)[0];
    const span = document.createElement("span");
    span.classList.add("cat-value");
    span.setAttribute("title", cat);
    span.innerText = cat;

    return span.outerHTML;
}

function fieldFormatter(row, cell, value, columnDef, dataContext) {
    // console.log(row, cell, value, columnDef, dataContext);
    // const { category, solution, solutions } = dataContext;
    // let soln = (solution === " - ") ? 0 : solution;
    let field = value || dataContext.flattenedPath || "";
    // if(!field) {
    //     if(solutions[category][soln]) {
    //         field = solutions[category][soln][0].path[0];
    //     } else {
    //         const sol = Object.keys(solutions[category])[0];
    //         field = solutions[category][sol][0].path[0];
    //     }
    // }
    field = field.replace(/>/g, " > ");
    const span = document.createElement("span");
    span.classList.add("field-value");
    span.setAttribute("title", field);
    span.innerText = field;
    if (dataContext.isUnavailable) {
        span.classList.add("disabled");
    }

    return span.outerHTML;
}

function deleteRow() {
    return "";
}

function conditionalFormat(row, cell, value, columnDef, dataContext) {
    // console.log(row, cell, value, columnDef, dataContext);
    let label = "Add";
    let disabled = false;
    if (!dataContext.isOwner || dataContext.isUnavailable) {
        disabled = true;
    }
    if (Array.isArray(dataContext.conditionalFormat) && dataContext.conditionalFormat.length > 0) {
        label = "Edit";
        if (!dataContext.isOwner || dataContext.isUnavailable) {
            disabled = false;
            label = "View";
        }
    }
    const _btn = new Button({
        label,
        darkTheme: false,
        disabled
    });
    return _btn.renderer.rootElement.outerHTML;
}

function sortTypeFormatter(row, cell, value, columnDef, dataContext) {
    const span = document.createElement("span");
    span.classList.add("sort-type-value");
    const fieldData = dataContext.field.split(">").reduce((acc, path) => {
        if (!acc) {
            return acc;
        }
        return acc[path];
    }, dataContext.solutions);
    if (!fieldData) {
        span.classList.add("disabled");
    }
    if (fieldData && fieldData.rowOrientedPropHeading) {
        span.classList.add("disabled");
    }
    span.setAttribute("title", "Sort type");
    let displayVal = "";
    if (!value) {
        return span.outerHTML;
    }
    switch (dataContext.dataType || fieldData.dataType) {
        case "number":
            displayVal = value === "desc" ? "Highest first" : "Lowest first";
            break;
        case "unixTime":
            displayVal = value === "desc" ? "Newest first" : "Oldest first";
            break;
        default:
            displayVal = value === "desc" ? "Z to A" : "A to Z";
    }
    span.innerText = displayVal;

    return span.outerHTML;
}

function aggregateFormatter(row, cell, value, columnDef, dataContext) {
    const span = document.createElement("span");
    span.classList.add("aggregate-value");
    const fieldData = dataContext.field.split(">").reduce((acc, path) => {
        if (!acc) {
            return acc;
        }
        return acc[path];
    }, dataContext.solutions);
    const dType = _.get(fieldData, "dataType", dataContext.dataType);
    // console.log(fieldData);
    if (dataContext.isUnavailable) {
        span.classList.add("disabled");
    }
    if (dType !== "number") {
        span.classList.add("disabled");
    } else {
        span.innerText = value || "None";
    }
    span.setAttribute("title", "Aggregate method");

    return span.outerHTML;
}

function sortOrderFormatter(row, cell, value, columnDef, dataContext) {
    const span = document.createElement("span");
    span.classList.add("sort-order");
    if (dataContext.sortType) {
        span.innerText = dataContext.sortOrder + 1;
    }
    if (dataContext.isUnavailable) {
        span.classList.add("disabled");
    }
    return span.outerHTML;
}

function rowOrientationFormatter(row, cell, value) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(false);
    }
    return checkbox.outerHTML;
}
function conditionDropdown(row, cell, value) {
    let inpt = document.createElement("select");
    inpt.setAttribute("row-id", `row-${row}`);
    inpt.setAttribute("data-type", value.dataType);

    inpt = createOption(inpt, value.dataType);
    setTimeout(() => {
        createSecondLevelFields(document.querySelector(`[row-id='row-${row}'`), value.options);
        document.querySelector(`[row-id='row-${row}'`).addEventListener("change", () => {
            createSecondLevelFields(event.target);
        });
    }, 1000);

    return inpt.outerHTML;
}

function colorPicker() {
    const inpt = document.createElement("input");
    inpt.setAttribute("type", "color");
    return inpt.outerHTML;
}

function createOption(inpt, dataType) {
    const list = CONDITIONAL_DATA[dataType];

    Object.keys(list).forEach((item) => {
        const option = document.createElement("option");
        option.text = list[item].label;
        option.value = item;
        inpt.options.add(option);
    });

    return inpt;
}

function createSecondLevelFields(elem, values = []) {
    const dataType = elem.getAttribute("data-type"),
        operator = elem.value,
        targetField = CONDITIONAL_DATA[dataType][operator];

    createField(elem, targetField, values);
}

function createField(inpt, targetFieldObj, values = []) {
    const cell = inpt.parentElement;
    // dataType = inpt.getAttribute("data-type");
    cell.querySelectorAll("input").forEach((inpt) => {
        inpt.remove();
    });

    switch (targetFieldObj.type) {
        case "text":
            for (let i = 0; i < targetFieldObj.fields; i++) {
                const field = document.createElement("input");
                field.setAttribute("type", targetFieldObj.type);
                cell.appendChild(field);
            }
            break;
        case "number":
            for (let i = 0; i < targetFieldObj.fields; i++) {
                const field = document.createElement("input");
                field.setAttribute("type", targetFieldObj.type);
                cell.appendChild(field);
            }
            break;
        case "radio":
            for (let i = 0; i < targetFieldObj.fields; i++) {
                const field = document.createElement("input");
                field.setAttribute("type", targetFieldObj.type);
                field.setAttribute("name", inpt.getAttribute("row-id"));
                if (i === 0) {
                    field.innerHTML = "True";
                } else {
                    field.innerHTML = "False";
                }
                cell.appendChild(field);
            }
            break;
        case "dropdown":
            if (!_.isEmpty(values)) {
                const field = document.createElement("select");
                values.forEach((item) => {
                    const option = document.createElement("option");
                    option.text = item;
                    option.value = item;
                    field.options.add(option);
                });
                field.setAttribute("type", targetFieldObj.type);
                cell.appendChild(field);
            }
            break;
        default:
            break;
    }
}

function countFormatter(row) {
    const rowNum = row + 1;
    const span = document.createElement("span");
    span.classList.add("row-count");
    span.setAttribute("title", "Row number " + rowNum);
    span.innerText = rowNum;
    return span.outerHTML;
}
